import client from './client';

export const register = (data) => client.post('/auth/register/', data);
export const login = (email, password) => client.post('/auth/login/', { email, password });
export const refreshToken = (refresh) => client.post('/auth/token/refresh/', { refresh });
export const getMe = () => client.get('/auth/me/');
export const requestPasswordReset = (email) => client.post('/auth/password-reset/', { email });
export const confirmPasswordReset = (token, password, password_confirm) =>
  client.post('/auth/password-reset/confirm/', { token, password, password_confirm });

export const validateEnterpriseCode = (code) =>
  client.post('/enterprises/validate/', { code });
